export default [
  {
    title: 'Financeiro',
    route: 'home',
    icon: 'TrendingUpIcon',
  },
  {
    title: 'Cobrança',
    route: 'second-page',
    icon: 'DollarSignIcon',
  },
  {
    title: 'Clientes',
    route: '',
    icon: 'UsersIcon',
  },
  {
    title: 'Fale conosco',
    route: '',
    icon: 'PhoneIcon',
  },
  
]
